var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 14.9987C3.33203 11.8554 3.33203 10.2854 4.3087 9.3087C5.28536 8.33203 6.85536 8.33203 9.9987 8.33203H29.9987C33.142 8.33203 34.712 8.33203 35.6887 9.3087C36.6654 10.2854 36.6654 11.8554 36.6654 14.9987C36.6654 15.7837 36.6654 16.177 36.422 16.422C36.177 16.6654 35.782 16.6654 34.9987 16.6654H4.9987C4.2137 16.6654 3.82036 16.6654 3.57536 16.422C3.33203 16.177 3.33203 15.782 3.33203 14.9987ZM3.33203 29.9987C3.33203 33.142 3.33203 34.712 4.3087 35.6887C5.28536 36.6654 6.85536 36.6654 9.9987 36.6654H29.9987C33.142 36.6654 34.712 36.6654 35.6887 35.6887C36.6654 34.712 36.6654 33.142 36.6654 29.9987V21.6654C36.6654 20.8804 36.6654 20.487 36.422 20.242C36.177 19.9987 35.782 19.9987 34.9987 19.9987H4.9987C4.2137 19.9987 3.82036 19.9987 3.57536 20.242C3.33203 20.487 3.33203 20.882 3.33203 21.6654V29.9987Z",
    fill: "#399E79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 5V10M28.3307 5V10",
    stroke: "#399E79",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpActive);
export default __webpack_public_path__ + "static/media/followUpActive.2e11dc42346a61cfd5d422b8887a08eb.svg";
export { ForwardRef as ReactComponent };